<template>
  <b-alert
    show
    class="tw-py-3 lg:tw-px-7 tw-font-medium tw-bg-[#ECE8F5] tw-border-none tw-mb-0 tw-flex tw-justify-center tw-items-center"
  >
    <div class="tw-text-md lg:tw-text-lg tw-align-middle tw-font-bold">
      Note: Due to the holidays, carrier shipping times and replies from your doctor & the Patient Care team may take extra time. Thank you for understanding.
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'BannersHolidayShippingNotice',
}
</script>